
import {createSlice, createSelector} from '@reduxjs/toolkit';
import {FormDiscountCodeInit} from "./model";


// import {INIT} from './../constants/status';

const initialState = {
    discountCodes: [],
    discountCodeForm: FormDiscountCodeInit,
};

const discountCodeSlice = createSlice({
    name: 'discountCode',
    initialState,
    reducers: {
        setDiscountCodes: (state, action) => {
            state.discountCodes = action.payload;
        },
        onDiscountCodeFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.discountCodeForm[name] = value;
        },
        onDiscountCodeConditionFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.discountCodeForm.condition[name] = value;
        },
        onDiscountCodeAmountFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.discountCodeForm.amount[name] = value;
        },
        initDiscountCodeForm: (state, action) => {
            state.discountCodeForm = action.payload;
        },
    },
});

export const {actions} = discountCodeSlice;
export const {
    setDiscountCodes,
    onDiscountCodeFormChange,
    onDiscountCodeConditionFormChange,
    onDiscountCodeAmountFormChange,
    initDiscountCodeForm,
} = actions;

// selectors

export const selDiscountCodes = (state) => state.discountCode.discountCodes;
export const selDiscountCodeForm = (state) => state.discountCode.discountCodeForm;

const reducer = {
    discountCode: discountCodeSlice.reducer,
};
export default reducer;